import { gql } from '@apollo/client';

export const STOCK_CAR_SEARCH = gql`
  query StockCarSearch(
    $stockIdentifier: StockIdentifierInput!
    $searchParameter: StockCarSearchParameterInput
    $groupIds: [String!]
    $imageIds: [String!]
  ) {
    stockCarSearch(stockIdentifier: $stockIdentifier, searchParameter: $searchParameter) {
      resultNumber
      search {
        criteria {
          id
          possibleItems {
            id
            number
          }
          selectedItems {
            id
            number
          }
        }
      }
      results {
        sort {
          id
          direction
        }
        paging {
          limit
          offset
        }
        cars {
          geoDistance {
            unitText
            value {
              formatted
              number
            }
          }
          stockCar {
            code {
              id
            }
            id
            vin
            weblink
            titleText
            model {
              name
              salesModelyear
              id {
                code
              }
            }
            modelInfo {
              genericModel {
                code
                text
              }
              modelyear
            }
            dealer {
              id
              name
              region
            }
            carPrices {
              label
              price {
                value
                valueAsText
                formattedValue
              }
              type
            }
            salesInfo {
              availableFromDateInfo {
                type
                value
              }
              orderStatusText
              saleOrderTypeText
            }
            qualityLabel {
              label
            }
            subtitleText
            cartypeText
            preUse {
              code
              text
            }
            commissionNumber
            images(groupIds: $groupIds, imageIds: $imageIds) {
              url
              type
              mimeType
              id {
                group
                image
              }
            }
            colorInfo {
              exteriorColor {
                colorInfo {
                  text
                }
                baseColorInfo {
                  code
                  text
                }
              }
              interiorColor {
                colorInfo {
                  text
                }
                baseColorInfo {
                  code
                  text
                }
              }
            }
            driveText
            dynamicAttributes {
              id
              value
            }
            engineInfo {
              fuel {
                code
                text
              }
            }
            carline {
              id
              name
            }
            gearText
            metaData {
              statImport
            }
            mileage {
              unitText
              value {
                formatted
                number
              }
            }
          }
        }
      }
    }
  }
`;
